import { ReloadOutlined } from '@ant-design/icons';
import { Spin, Alert, Button, message } from 'antd';
import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../app/store';
import { ScreenLayout } from '../../../components/index';
import { useCheckDashboardAccessQuery } from '../../../services/dashboardApi';
import { DashboardContainer, IframeContainer, ErrorContainer } from './styles';

export function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { token } = useSelector((state: RootState) => state.auth);

  const {
    data: dashboardData,
    isError,
    refetch,
  } = useCheckDashboardAccessQuery(undefined);

  useEffect(() => {
    if (dashboardData) {
      setIsLoading(false);
    }
  }, [dashboardData]);

  useEffect(() => {
    if (isError) {
      setHasError(true);
      setIsLoading(false);
      message.error('Erro ao carregar dashboard');
    }
  }, [isError]);

  const handleIframeLoad = useCallback(() => {
    setHasError(false);
  }, []);

  const handleRetry = useCallback(() => {
    setIsLoading(true);
    setHasError(false);
    refetch();
  }, [refetch]);

  return (
    <ScreenLayout title="Painel">
      <DashboardContainer>
        {isLoading && (
          <div className="loading-container">
            <Spin size="large" tip="Carregando dashboard..." />
          </div>
        )}

        {hasError && (
          <ErrorContainer>
            <Alert
              message="Erro ao carregar dashboard"
              description={
                <Button
                  type="primary"
                  icon={<ReloadOutlined />}
                  onClick={handleRetry}
                >
                  Tentar novamente
                </Button>
              }
              type="error"
              showIcon
            />
          </ErrorContainer>
        )}

        <IframeContainer $isLoading={isLoading} $hasError={hasError}>
          {!isLoading && !hasError && dashboardData?.dashboard_url && (
            <iframe
              src={dashboardData.dashboard_url}
              frameBorder="0"
              width="100%"
              height="100%"
              title="Dashboard Operacional"
              onLoad={handleIframeLoad}
              allowTransparency
              sandbox="allow-same-origin allow-scripts allow-forms"
            />
          )}
        </IframeContainer>
      </DashboardContainer>
    </ScreenLayout>
  );
}
